import { blinkConstants } from '@thoughtspot/blink-constants';
const isToastVisible = 'isToastMessageVisible';
const toastMessage = 'ToastMessage';
const sourceToPricingPage = 'sourceToPricingPage';
const storage = new Map();
const context = new Map();
const getSessionStorageItem = (key) => {
    return storage[key] || '';
};
const setSessionStorageItem = (key, value) => {
    storage[key] = value.toString();
};
const getSessionContextItem = (key) => {
    if (context.has(key)) {
        return context.get(key);
    }
    return null;
};
const setSessionContextItem = (key, value) => {
    context.set(key, value);
};
export const clearSessionContext = () => {
    context.clear();
};
export const setHomeMetadataListConfig = (config) => {
    setSessionContextItem(blinkConstants.preferenceValues.HOME_METADATA_LIST_CONFIG, config);
};
export const getHomeMetadataListConfig = () => {
    return getSessionContextItem(blinkConstants.preferenceValues.HOME_METADATA_LIST_CONFIG);
};
export const setFavouritesMetadataListConfig = (config) => {
    setSessionContextItem(blinkConstants.preferenceValues.FAVOURITES_METADATA_LIST_CONFIG, config);
};
export const getFavouritesMetadataListConfig = () => {
    return getSessionContextItem(blinkConstants.preferenceValues.FAVOURITES_METADATA_LIST_CONFIG);
};
export const setCreatedByMeMetadataListConfig = (config) => {
    setSessionContextItem(blinkConstants.preferenceValues.CREATED_BY_ME_METADATA_LIST_CONFIG, config);
};
export const getCreatedByMeMetadataListConfig = () => {
    return getSessionContextItem(blinkConstants.preferenceValues.CREATED_BY_ME_METADATA_LIST_CONFIG);
};
export const setAnswersMetadataListConfig = (config) => {
    setSessionContextItem(blinkConstants.preferenceValues.ANSWERS_METADATA_LIST_CONFIG, config);
};
export const getAnswersMetadataListConfig = () => {
    return getSessionContextItem(blinkConstants.preferenceValues.ANSWERS_METADATA_LIST_CONFIG);
};
export const setLiveboardsMetadataListConfig = (config) => {
    setSessionContextItem(blinkConstants.preferenceValues.LIVEBOARDS_METADATA_LIST_CONFIG, config);
};
export const getLiveboardsMetadataListConfig = () => {
    return getSessionContextItem(blinkConstants.preferenceValues.LIVEBOARDS_METADATA_LIST_CONFIG);
};
export const showToastMessage = (showToast) => {
    setSessionStorageItem(isToastVisible, showToast);
};
export const setToastMessage = (message) => {
    setSessionStorageItem(toastMessage, message);
};
export const getToastMessage = () => {
    return getSessionStorageItem(toastMessage);
};
export const isToastMessageVisible = () => {
    return getSessionStorageItem(isToastVisible) === 'true';
};
export const getSourceToPricingPage = () => {
    return getSessionStorageItem(sourceToPricingPage);
};
export const setSourceToPricingPage = (value) => {
    setSessionStorageItem(sourceToPricingPage, value);
};
//# sourceMappingURL=session-storage.js.map